/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const bossPickUpStyles = (props) => {
  const style1 = ` margin: 28px 24px 24px 0;
 padding: 16px;
 border-radius: 5px;
 max-width: 325px;
 height: 98px;
 border: solid 1px ${props.theme.colors.CARD.BORDER};`;
  const style2 = `padding:0px; margin: 18px -16px 5px -15px;`;
  if (props.bossSwitchEnabled || props.isNewEddViewCheckout) {
    if (props.isSPC) {
      return style2;
    }
    return null;
  }
  return style1;
};

export default css`
  ${(props) =>
    props.isLoginV2FlowEnabled
      ? `
      .giftServicesField {
    display: inline-block;
    width: auto;
    .CheckBox__text {
      padding-top: 6px;
    }
  }
  .checkbox-header {
    width: 100%;
    display: flex;

    .title {
      align-items: center;
      &.no-visile {
        position: static;
        font-size: ${props.theme.fonts.fontSize.body.bodytext.copy5}px;
        font-weight: ${props.theme.fonts.fontWeight.semiBold};
        border: 0;
      }
    }
    .title.no-visile::after {
      display: none;
    }
  }
      `
      : ``};

  .toolTip-wrapper {
    display: flex;
    align-items: center;
    margin-left: 6px;
    ${(props) => (props.bossSwitchEnabled ? `margin-top:5px;` : ``)}
  }

  .spc-card-skeleton {
    padding: 24px 15px 24px 13px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    border-radius: 10px;
    box-shadow: 0 8px 20px 0 rgb(0 0 0 / 12%), 0 2px 3px 0 rgb(0 0 0 / 20%);
    background-color: ${(props) => props.theme.colors.WHITE};
    overflow-y: auto;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 32px;
    }
  }

  .change-store-link {
    margin-left: 0px;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
  }
  .store-name {
    margin-bottom: 3px;
  }
  .pickup-header {
    width: 60%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 71%;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 50%;
    }
  }

  .pickup-loader {
    margin-top: 24px;
  }
  .pickup-location-wrapper {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  .helper-text-parent {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
  }

  .helper-text-child {
    width: 674px;
    height: 14px;
    margin: 0px 0 27px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 12px;
    line-height: 1.14;
    letter-spacing: 0.2px;
    color: var(--${(props) => props.theme.colors.BLACK});
  }

  .alternate-pickup-parent {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .alternate-pickup-child {
    width: 311px;
    height: 22px;
    margin: 25px 4px 32px 14px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 16px;
    line-height: 1.14;
    letter-spacing: 0.2px;
    color: var(--${(props) => props.theme.colors.BLACK});
  }

  .add-an-alternative-p {
    width: 311px;
    height: 22px;
    margin: 25px 4px 32px 14px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 16px;
    color: var(--${(props) => props.theme.colors.BLACK});
  }

  .text-style {
    margin-top: 5px;
  }

  .pickup-location-parent {
    display: flex;
    width: 100%;
  }

  .pickup-location-card {
    width: auto;
    margin: 28px 24px 24px 0;

    ${(props) => bossPickUpStyles(props)}
    min-width: 280px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isSPC
          ? props.bossSwitchEnabled || props.isNewEddViewCheckout
            ? `
          margin: 18px -15px 5px -15px;`
            : `margin: 28px 24px 24px 0;`
          : ''};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isSPC
          ? props.bossSwitchEnabled || props.isNewEddViewCheckout
            ? `
          margin: 18px 0px 5px -14px;`
            : `margin: 28px 24px 24px 0;`
          : ''};
    }
  }
  .new-location-style {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .pickup-location-container {
    display: flex;
    align-items: center;
    width: auto;
  }
  .confirmation-fullfillment-details {
    padding-top: 4px;
  }
  .pickup-location-name {
    height: 14px;
    margin: ${(props) => (props.bossSwitchEnabled ? '0 5px 0 0' : ' 0 0 4px')};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 16px;
    font-weight: 500;
    color: var(--${(props) => props.theme.colors.BLACK});
    text-transform: capitalize;
  }

  .pickup-location-address {
    width: 209px;
    height: 18px;
    margin: 4px 14px 0px 0;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 14px;
    line-height: 1.29;
    color: var(--${(props) => props.theme.colors.BLACK});
  }
  .pickup-location-city-state {
    font-size: 14px;
    color: var(--${(props) => props.theme.colors.BLACK});
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }
  .sms-updates-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sms-updates-wrapper {
    background-color: #f4faff;
    padding: 16px 32px;
    margin: 32px -47px -32px;
  }

  .sms-updates-container .CheckBox__input:before {
    border-radius: 2px;
    border: 1px solid #005d95;
  }

  .sms-updates-container .CheckBox__input:checked:before {
    background: #005d95;
    border: 1px solid #005d95;
    border-radius: 2px;
  }

  .pickup-location-count {
    padding-right: 5px;
    height: 18px;
    margin: 9px 0 0;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 14px;
    line-height: 1.29;
    color: ${(props) => props.theme.colors.GREEN};
  }

  .pickup-location-date {
    height: 18px;
    margin: 9px 0 0;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 14px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    line-height: 1.29;
    color: ${(props) => props.theme.colors.GREEN};
  }

  .send-order-update {
    display: flex;
  }

  .spc-order-update {
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.small.secondary}px`};
    }
  }
  .shake-pickup {
    animation-name: shake;
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  .sms-subscription-confirmation {
    display: flex;
    align-items: center;
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translateX(-10px);
    }
    20%,
    40%,
    60%,
    80% {
      transform: translateX(10px);
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
